// ============================================================================
// Helpers
// ============================================================================
// Waits for quick filter pills to exist in the DOM, then invokes callback (with optional retries)
function waitForQuickFilters(callback, retries = 10) {
  const quickFiltersExist = document.querySelector(
    ".quick-filter-main .custom-button.selected a",
  )
  if (quickFiltersExist) {
    callback()
  } else if (retries > 0) {
    setTimeout(() => waitForQuickFilters(callback, retries - 1), 100)
  } else {
    callback()
  }
}

// Gets the stored quick filter pill order array from localStorage
function getPillOrderArr() {
  try {
    return JSON.parse(localStorage.getItem("quickFilterOrderArr") || "[]")
  } catch {
    return []
  }
}
// Stores the quick filter pill order array to localStorage
function setPillOrderArr(arr) {
  localStorage.setItem("quickFilterOrderArr", JSON.stringify(arr))
}
let quickFilterPillOrder = 0
// Resets all filters and reloads the page content and filters
function resetAllFiltersAndReload() {
  const url = new URL(window.location.href)
  url.search = ""
  history.replaceState({}, "", url.pathname)
  if (typeof loadContent === "function") loadContent()
  if (typeof renderFilters === "function") renderFilters()
  filterSelectionTag.track()
}
window.skipScrollBecauseOfQuickFilterClick = false
document.addEventListener("mousedown", function (event) {
  const isQuickFilter = event.target.closest(".quick-filter-pill")
  window.skipScrollBecauseOfQuickFilterClick = !!isQuickFilter
})
// Scrolls the quick filter container to the left, unless a pill click prevents it
function tryScrollLeft() {
  if (window.skipScrollBecauseOfQuickFilterClick) {
    window.skipScrollBecauseOfQuickFilterClick = false
    return
  }
  if (window.quickFilterClickPreventScroll) {
    return
  }
  const pillContainer = document.querySelector(".quick-filter-main")
  if (pillContainer) {
    pillContainer.scrollTo({ left: 0, behavior: "smooth" })
  }
}
// Gets the legacy quick filter pill order from localStorage
function getPillOrder() {
  return JSON.parse(localStorage.getItem("quickFilterOrder") || "[]")
}
// Sets the legacy quick filter pill order in localStorage
function setPillOrder(order) {
  localStorage.setItem("quickFilterOrder", JSON.stringify(order))
}
// Builds a unique key for a filter pill
function getPillKey(key, value) {
  return key + "-" + value
}
// Creates a DOM element from an HTML string
function createElementFromHTML(htmlString) {
  const div = document.createElement("div")
  div.innerHTML = htmlString.trim()
  return div.firstChild
}
// Normalizes a filter value for comparison (strips special chars, lowercases, trims)
function normalizeFilterValue(val) {
  if (typeof val !== "string") return ""
  return val
    .replace(/\+/g, " ")
    .replace(/%20/g, " ")
    .replace(/[^a-zA-Z0-9 ]+/g, "")
    .toLowerCase()
    .trim()
}
// Checks if the given filter value matches any quick filter pill in the DOM
function isQuickFilterMatch(filterValue) {
  const normalized = filterValue.trim().toLowerCase()
  const quickFilterSpans = document.querySelectorAll(".quick-filter-pill")
  for (const span of quickFilterSpans) {
    const label = span.textContent.trim().toLowerCase()
    const dataVal = span
      .getAttribute("data-p")
      ?.split("|")[1]
      ?.trim()
      .toLowerCase()
    if (normalized === label || normalized === dataVal) {
      return true
    }
  }
  return false
}
// Creates and appends a quick filter pill to the container, if not already present
function createQuickFilterPill(
  type,
  value,
  label,
  isMostPopular = false,
  isQuickFilter = false,
  isQuickFilterMatch = true,
) {
  if (isMostPopular) return
  const container = document.querySelector(".quick-filters-container")
  if (!container) return
  const existing = container.querySelector(`[data-${type}="${value}"]`)
  if (existing) return
  const pillElement = document.createElement("span")
  pillElement.className = "quick-filter-pill"
  pillElement.setAttribute(`data-${type}`, value)
  pillElement.textContent = label
  if (!pillElement || !(pillElement instanceof Node) || !container) return
  if (pillElement && container) {
    container.appendChild(pillElement)
  }
}
// Prevent pill flicker: lock rendering for 200ms after quick filter click
window.justClickedQuickFilter = false
window.justClickedQuickFilterTimestamp = null
// ============================================================================
// Pill Logic, Event Bindings, AJAX/Product Grid Updates, Drawer Sync, Show More
// ============================================================================

// Main entry point: handles pill logic, event bindings, AJAX loading, drawer sync, and show more
document.addEventListener("DOMContentLoaded", () => {
  // --- [PillCreate] Function to inject unmatched "Most Popular" pills from URL ---
  // Normalizes the label for "Most Popular" filters for comparison
  function normalizeMostPopular(val) {
    return decodeURIComponent(val || "")
      .replace(/\+/g, " ")
      .replace(/%20/g, " ")
      .replace(/\s+/g, " ")
      .replace(/[^a-z0-9 ]+/gi, "")
      .toLowerCase()
      .trim()
  }
  // Injects unmatched "Most Popular" pills from the URL that are checked in the drawer but not present as quick filter buttons
  function createUnmatchedMostPopularPills() {
    // Only run this logic for the "most_popular" filter context
    const params = new URLSearchParams(window.location.search)
    const activeMostPopularFilters =
      params.getAll("filter.p.m.custom.most_popular") || []
    const pillsContainer = document.querySelector(".quick-filters-container")
    if (!pillsContainer) return

    function normalizeMostPopular(val) {
      return decodeURIComponent(val || "")
        .replace(/\+/g, " ")
        .replace(/%20/g, " ")
        .replace(/\s+/g, " ")
        .replace(/[^a-z0-9 ]+/gi, "")
        .toLowerCase()
        .trim()
    }

    activeMostPopularFilters.forEach((label) => {
      if (!label) return
      // Compare filter param values, not just label/text, for language-agnostic deduplication
      const quickBtn = Array.from(
        document.querySelectorAll(".quick-filter-main .custom-button a"),
      ).find((a) => {
        const btnUrl = new URL(a.href, location.origin)
        const btnVal = btnUrl.searchParams.get("filter.p.m.custom.most_popular")
        return (
          btnVal && btnVal.trim().toLowerCase() === label.trim().toLowerCase()
        )
      })
      if (quickBtn && quickBtn.classList.contains("selected")) {
        return
      }
      // Only show pill if option is checked in drawer
      const drawerCheckbox = Array.from(
        document.querySelectorAll(
          'input[name="filter.p.m.custom.most_popular"]',
        ),
      ).find(
        (input) =>
          decodeURIComponent(input.value).trim().toLowerCase() ===
          label.trim().toLowerCase(),
      )
      if (!drawerCheckbox || !drawerCheckbox.checked) return

      // Only create pill if NOT already present (prevents duplication)
      const pillExists = Array.from(
        pillsContainer.querySelectorAll(
          '.quick-filter-pill[data-p^="filter.p.m.custom.most_popular|"]',
        ),
      ).some(
        (pill) =>
          (pill.getAttribute("data-p")?.split("|")[1] || pill.textContent)
            .trim()
            .toLowerCase() === label.trim().toLowerCase(),
      )
      if (pillExists) return

      // Otherwise, create the pill
      const pill = document.createElement("span")
      pill.className = "quick-filter-pill"
      pill.textContent = label
      pill.dataset.p = `filter.p.m.custom.most_popular|${label}`

      pill.addEventListener("click", function () {
        const param = pill.getAttribute("data-p")
        if (param) {
          const [name, value] = param.split("|")
          const urlParams = new URLSearchParams(window.location.search)
          const values = urlParams.getAll(name)
          const newValues = values.filter((v) => v !== value)
          urlParams.delete(name)
          newValues.forEach((v) => urlParams.append(name, v))
          history.replaceState(
            {},
            "",
            `${window.location.pathname}?${urlParams}`,
          )
          if (typeof loadContent2 === "function") {
            loadContent2(window.location.pathname + "?" + urlParams.toString())
          }
        }
      })

      if (pill && pillsContainer) {
        pillsContainer.insertBefore(pill, pillsContainer.firstChild)
      }
    })
  }
  // [QuickScroll] Setup quick filter pill click handler to set skipScrollBecauseOfQuickFilterClick
  document.querySelectorAll(".quick-filter-pill").forEach((pill) => {
    pill.addEventListener("click", () => {
      skipScrollBecauseOfQuickFilterClick = true
      setTimeout(() => {
        skipScrollBecauseOfQuickFilterClick = false
      }, 1500)
    })
  })
  const quickWrapper = document.querySelector(".quick-filter-main")
  if (!quickWrapper) return

  const drawerSelector = "#FacetFiltersFormMobile, #FacetFiltersForm"
  let drawerForm = document.querySelector(drawerSelector)
  const currency = Shopify.currency?.symbol || "$"
  let userSelectedSort = false
  let userManuallySorted = false

  const quickContainer = document.createElement("div")
  quickContainer.className = "quick-filters-container"
  // Always append quickContainer safely at the leftmost position
  if (quickWrapper && quickContainer instanceof HTMLElement) {
    quickWrapper.appendChild(quickContainer)
  }

  // --- [REMOVED] Ensure quick filters container uses flex layout and order property ---
  // The pill order is controlled entirely by the JS array (pillOrderArr) and insertion point,
  // not by CSS flex-direction or order. All pills are inserted using
  // quickContainer.insertBefore(pill, quickContainer.firstChild), so the newest pill appears leftmost.

  const clearFilters =
    document.querySelector(".active-facets__button-remove").textContent ||
    "Clear Filters"
  const clearAllBtn = document.createElement("button")
  clearAllBtn.textContent = clearFilters
  clearAllBtn.className =
    "quick-filter-clear-all quick-filter-clear-all-desktop btn-collection-filter button button--tertiary"
  clearAllBtn.style.display = "none"
  quickWrapper.appendChild(clearAllBtn)

  const drawerDetails = document.querySelector(".mobile-facets__disclosure")

  if (drawerDetails) {
    drawerDetails.addEventListener("toggle", () => {
      if (drawerDetails.open) {
        // Reopen all inner <details> inside drawer
        drawerDetails
          .querySelectorAll(".mobile-facets__details")
          .forEach((section) => {
            section.open = true
          })
      }
    })
  }

  // Utility: Debounces a function call (delays execution until after wait ms have elapsed)
  function debounce(func, wait = 300) {
    let timeout
    return (...args) => {
      clearTimeout(timeout)
      timeout = setTimeout(() => func.apply(this, args), wait)
    }
  }

  // Extracts all filter values from both desktop and mobile forms into an object
  function getFilters() {
    const filters = {}
    const forms = [
      document.querySelector("#FacetFiltersForm"),
      document.querySelector("#FacetFiltersFormMobile"),
    ]

    forms.forEach((form) => {
      if (!form) return

      const data = new FormData(form)
      for (const [key, value] of data.entries()) {
        const trimmed = value?.toString().trim()

        if (!trimmed) continue

        const isPriceFilter =
          key === "filter.v.price.gte" || key === "filter.v.price.lte"
        if (isPriceFilter && trimmed === "") continue

        filters[key] = filters[key] || []
        filters[key].push(trimmed)
      }
    })

    // Remove default sort if not explicitly selected
    if (!userSelectedSort && filters["sort_by"]?.[0] === "manual") {
      delete filters["sort_by"]
    }

    return filters
  }

  // Converts filter object into a URLSearchParams string, handling arrays and primitives
  function buildCleanParams(params = {}) {
    const cleanParams = new URLSearchParams()

    for (const [key, value] of Object.entries(params)) {
      if (
        typeof value === "string" ||
        typeof value === "number" ||
        typeof value === "boolean"
      ) {
        cleanParams.set(key, value)
      } else if (Array.isArray(value)) {
        for (const val of value) {
          cleanParams.append(key, val)
        }
      }
    }

    return cleanParams.toString()
  }

  // Updates the URL with new filters and triggers AJAX reload of content
  async function updateURL(filters) {
    // Remove default sort unless user clicked a sort radio
    if (!userManuallySorted && filters["sort_by"]?.[0] === "manual") {
      delete filters["sort_by"]
    }

    const ps = buildCleanParams(filters)
    const newUrl = ps.toString()
      ? `${window.location.pathname}?${ps}`
      : window.location.pathname
    if (filters["sort_by"]?.[0] === "manual") {
      delete filters["sort_by"] // remove default unless user changed it
    }
    history.replaceState({}, "", newUrl)
    loadContent(filters)
  }

  // Extracts available "Most Popular" options from the DOM for button/pill rendering
  function extractLiveMostPopularOptionsFromDOM(container = document) {
    return Array.from(
      container.querySelectorAll(
        'input[name="filter.p.m.custom.most_popular"]',
      ),
    )
      .filter((input) => !input.disabled)
      .map((input) => decodeURIComponent(input.value?.trim() || ""))
  }

  let mostPopularOptionsFromResponse = extractLiveMostPopularOptionsFromDOM()

  // Loads filtered product grid and related UI via AJAX, replaces DOM sections, and rebinds events
  async function loadContent(filters) {
    currentPage = 1
    try {
      // Disable all quick filter pills during loading
      document
        .querySelectorAll(".quick-filter-pill")
        .forEach((pill) => pill.classList.add("disabled"))

      const cleanUrl = `${window.location.pathname}?${buildCleanParams(filters)}`
      const res = await fetch(cleanUrl)
      const html = await res.text()
      const tmp = new DOMParser().parseFromString(html, "text/html")

      // Replace product grid
      const newGrid = tmp.querySelector("#ProductGridContainer")
      const curGrid = document.querySelector("#ProductGridContainer")
      if (newGrid && curGrid) {
        curGrid.innerHTML = newGrid.innerHTML
        swatchChangesCard()
        if (typeof theme_custom?.percussiveMassageSlider === "function") {
          theme_custom.percussiveMassageSlider()
        }
        // Delay count update to ensure grid has been rendered
        setTimeout(() => {
          const updatedGrid = document.querySelector("#ProductGridContainer")
          const visibleCount =
            updatedGrid?.querySelectorAll(".grid__item").length || 0
          const countElem = document.querySelector(".custom-show-product")
          if (countElem) countElem.textContent = visibleCount.toString()
        }, 0)
      }
      const totalElem = document.querySelector(".custom-total-product")

      const newTotalElem = tmp.querySelector(".custom-total-product")
      if (newTotalElem && totalElem) {
        totalElem.textContent = newTotalElem.textContent
      }

      const progress = document.querySelector(".load-more-progress-bar")
      const countElem = document.querySelector(".custom-show-product")
      if (progress && countElem && totalElem) {
        const total = parseInt(totalElem.textContent || "0")
        const shown = parseInt(countElem.textContent || "0")
        progress.style.width = `${(shown / total) * 100}%`
      }

      // Replace product count
      const newCount = tmp.querySelector("#ProductCount, #ProductCountDesktop")
      const curCount = document.querySelector(
        "#ProductCount, #ProductCountDesktop",
      )
      if (newCount && curCount)
        curCount.innerHTML = newCount.innerHTML.replace("products", "Products")

      // Replace drawer filters (mobile) - preserve scroll and avoid full replacement
      const newDrawer = tmp.querySelector("#FacetFiltersFormMobile")
      const curDrawer = document.querySelector("#FacetFiltersFormMobile")
      if (curDrawer && newDrawer) {
        const innerOld = curDrawer.querySelector(".mobile-facets__inner")
        const innerNew = newDrawer.querySelector(".mobile-facets__inner")

        if (innerOld && innerNew) {
          const scrollTop = innerOld.scrollTop

          const mainOld = innerOld.querySelector(".mobile-facets__main")
          const mainNew = innerNew.querySelector(".mobile-facets__main")

          if (mainOld && mainNew) {
            mainOld.innerHTML = mainNew.innerHTML
          }

          setTimeout(() => {
            innerOld.scrollTop = scrollTop
            syncAll() // rebind filters
          }, 0)
        }
      }

      const newDrawerDesktop = tmp.querySelector("#FacetFiltersForm")
      const curDrawerDesktop = document.querySelector("#FacetFiltersForm")
      if (newDrawerDesktop && curDrawerDesktop) {
        const scrollY = curDrawerDesktop.scrollTop
        curDrawerDesktop.replaceWith(newDrawerDesktop)
        newDrawerDesktop.scrollTop = scrollY
      }

      // ✅ Replace .load-more-part after filters are applied
      const newLoadMore = tmp.querySelector(".load-more-part")
      const curLoadMore = document.querySelector(".load-more-part")
      if (newLoadMore && curLoadMore) {
        curLoadMore.replaceWith(newLoadMore.cloneNode(true))
      }

      // Re-extract most popular options
      mostPopularOptionsFromResponse = extractLiveMostPopularOptionsFromDOM(tmp)

      // Rebind everything
      syncAll()
      // Re-bind Show More button using global rebind
      setTimeout(() => {
        rebindShowMoreButton()
      }, 0)
      // --- Remove unavailable unmatched Most Popular pills after content load ---
      removeUnavailableUnmatchedPills(html)
      // --- [PATCH] Ensure unmatched Most Popular pills are created after DOM/filter updates ---
      if (typeof createUnmatchedMostPopularPills === "function") {
        requestAnimationFrame(() => {
          setTimeout(() => {
            createUnmatchedMostPopularPills()
            // [PATCH] Ensure pills are cleaned up after all DOM and pill rendering is complete
            setTimeout(removeUnavailableUnmatchedPills, 100)
          }, 100)
        })
      }
      filterSelectionTag.track()
    } catch (e) {
      // Do nothing
    } finally {
      document
        .querySelectorAll(".quick-filter-pill")
        .forEach((pill) => pill.classList.remove("disabled"))
      if (typeof attachMobileClearHandler === "function")
        attachMobileClearHandler()
    }
    window.justClickedQuickFilter = false
    window.justClickedQuickFilterTimestamp = null
  }

  // --- Helper to remove unavailable or unmatched Most Popular pills ---
  // Removes unmatched "Most Popular" pills that are no longer available/checked in the drawer
  function removeUnavailableUnmatchedPills() {
    setTimeout(() => {
      const pills = Array.from(
        document.querySelectorAll(
          '.quick-filter-pill[data-p^="filter.p.m.custom.most_popular|"]',
        ),
      )
      pills.forEach((pill) => {
        const pillRaw = pill.getAttribute("data-p")?.split("|")[1] || ""
        const normalized = pillRaw
          .replace(/\+/g, " ")
          .replace(/%20/g, " ")
          .replace(/\s+/g, " ")
          .replace(/[^a-z0-9 ]+/gi, "")
          .toLowerCase()
          .trim()
        const drawerCheckbox = Array.from(
          document.querySelectorAll(
            'input[name="filter.p.m.custom.most_popular"]',
          ),
        ).find((input) => {
          return (
            (input.value || "")
              .replace(/\+/g, " ")
              .replace(/%20/g, " ")
              .replace(/\s+/g, " ")
              .replace(/[^a-z0-9 ]+/gi, "")
              .toLowerCase()
              .trim() === normalized
          )
        })
        if (!drawerCheckbox || !drawerCheckbox.checked) {
          pill.remove()
        }
      })
    }, 50)
  }

  // Sets up price filter input events to sanitize and trigger AJAX updates
  function setupPriceFilters() {
    if (!drawerForm) return

    const priceInputs = [
      drawerForm.querySelector('input[name="filter.v.price.gte"]'),
      drawerForm.querySelector('input[name="filter.v.price.lte"]'),
    ].filter(Boolean)

    priceInputs.forEach((input) => {
      // Clone input to remove problematic event listeners
      const newInput = input.cloneNode(true)
      input.replaceWith(newInput)

      // Store current cursor position
      let cursorPosition = 0

      newInput.addEventListener("keydown", (e) => {
        cursorPosition = e.target.selectionStart
        if (e.key === "Enter") {
          applyPriceFilters()
        }
      })

      newInput.addEventListener("input", (e) => {
        const newValue = e.target.value.replace(/[^0-9]/g, "")
        if (newValue !== e.target.value) {
          e.target.value = newValue
          newInput.setSelectionRange(cursorPosition, cursorPosition)
        }
      })

      newInput.addEventListener("blur", debounce(applyPriceFilters, 300))
    })
  }

  // Clears all sort radio buttons and removes their active states
  function clearSortRadios() {
    // Uncheck all sort radios
    document
      .querySelectorAll('.mobile-facets__checkbox[type="radio"]')
      .forEach((radio) => {
        radio.checked = false
      })
    // Remove active class from labels
    document.querySelectorAll(".mobile-facets__label").forEach((label) => {
      label.classList.remove("active")
    })
  }

  // Rebinds price range input events in <price-range> components to trigger AJAX updates
  function rebindPriceRangeInputs() {
    const priceComponents = document.querySelectorAll("price-range")
    priceComponents.forEach((range) => {
      const minInput = range.querySelector('input[name="filter.v.price.gte"]')
      const maxInput = range.querySelector('input[name="filter.v.price.lte"]')

      if (!minInput || minInput.classList.contains("price-bound")) return

      const updatePrice = () => {
        const filters = getFilters()
        const minVal = minInput.value.trim()
        const maxVal = maxInput.value.trim()

        // Only include valid prices
        if (minVal && !isNaN(minVal)) {
          filters["filter.v.price.gte"] = [minVal]
        } else {
          delete filters["filter.v.price.gte"]
        }

        if (maxVal && !isNaN(maxVal)) {
          filters["filter.v.price.lte"] = [maxVal]
        } else {
          delete filters["filter.v.price.lte"]
        }

        if (minVal || maxVal) {
          updateURL(filters)
        }
      }

      // Blur triggers AJAX update
      minInput.addEventListener("blur", updatePrice)
      maxInput.addEventListener("blur", updatePrice)

      // Enter key
      minInput.addEventListener("keydown", (e) => {
        if (e.key === "Enter") {
          e.preventDefault()
          updatePrice()
        }
      })
      maxInput.addEventListener("keydown", (e) => {
        if (e.key === "Enter") {
          e.preventDefault()
          updatePrice()
        }
      })

      // Prevent instant reload on typing
      minInput.addEventListener("input", (e) => e.stopPropagation())
      maxInput.addEventListener("input", (e) => e.stopPropagation())

      // Mark as bound
      minInput.classList.add("price-bound")
      maxInput.classList.add("price-bound")
    })
  }

  // Removes the 'data-max' attribute from price range inputs to allow any value
  function fixPriceRangeDataMax() {
    document
      .querySelectorAll('price-range input[name="filter.v.price.gte"]')
      .forEach((input) => {
        if (input.hasAttribute("data-max")) {
          input.removeAttribute("data-max") // 🛠 remove limit
        }
      })

    document
      .querySelectorAll('price-range input[name="filter.v.price.lte"]')
      .forEach((input) => {
        if (input.hasAttribute("data-max")) {
          input.removeAttribute("data-max") // 🛠 remove limit
        }
      })
  }

  // Safely binds blur and Enter key events to price inputs to trigger filter updates
  function bindPriceEventsSafely() {
    document
      .querySelectorAll('price-range input[name^="filter.v.price"]')
      .forEach((input) => {
        if (input.classList.contains("price-bound")) return

        input.addEventListener("blur", () => {
          const filters = getFilters()
          updateURL(filters)
        })

        input.addEventListener("keydown", (e) => {
          if (e.key === "Enter") {
            e.preventDefault()
            const filters = getFilters()
            updateURL(filters)
          }
        })

        input.classList.add("price-bound")
      })
  }

  // Binds the drawer clear button to reset filters and trigger AJAX reload
  function setupDrawerClearButton() {
    const drawerClearBtn = document.querySelector(
      ".mobile-facets__clear.button--secondary",
    )

    if (!drawerClearBtn || drawerClearBtn.classList.contains("bound")) return

    drawerClearBtn.addEventListener("click", (e) => {
      e.preventDefault()

      // Reset URL to base collection
      const url = new URL(
        window.location.origin + drawerClearBtn.getAttribute("href"),
      )

      // Wipe filters from the drawer checkboxes
      document
        .querySelectorAll("#FacetFiltersFormMobile input[type='checkbox']")
        .forEach((el) => {
          el.checked = false
        })

      // Clear price inputs if needed
      document
        .querySelectorAll("#FacetFiltersFormMobile input[type='text']")
        .forEach((el) => {
          el.value = ""
        })

      // Trigger AJAX content reload
      loadContent({}) // empty filters
    })

    drawerClearBtn.classList.add("bound")
  }

  // Rebinds all filter, sort, and price events; syncs UI state; ensures pill and drawer consistency
  function syncAll() {
    // Rebind drawerForm element
    drawerForm = document.querySelector(drawerSelector)

    // Prevent Dawn's default form submission behavior
    document
      .querySelectorAll("#FacetFiltersForm, #FacetFiltersFormMobile")
      .forEach((form) => {
        form.addEventListener("submit", (e) => e.preventDefault())
      })

    // Rebind all checkbox events to submit filters
    if (drawerForm) {
      drawerForm.querySelectorAll('input[type="checkbox"]').forEach((input) => {
        if (!input.classList.contains("bound")) {
          input.addEventListener("change", (e) => {
            e.preventDefault()
            e.stopPropagation()
            window.quickFilterJustAdded = true
            updateURL(getFilters())
            // No longer remove pills for checked Most Popular inputs here; handled in removeUnavailableUnmatchedPills.
          })
          input.classList.add("bound")
        }
      })
    }

    // Define and rebind sort_by radios
    function handleSortChange(e) {
      const radio = e.target
      if (!radio || !radio.value) return

      const filters = getFilters()
      filters["sort_by"] = [radio.value]

      userSelectedSort = true
      userManuallySorted = true

      window.quickFilterJustAdded = true
      updateURL(filters)
    }

    const sortRadios = document.querySelectorAll('input[name="sort_by"]')
    sortRadios.forEach((radio) => {
      radio.removeEventListener("change", handleSortChange)
      radio.addEventListener("change", handleSortChange)
    })

    // Rebind price input events (call only once)
    bindPriceEventsSafely()
    rebindPriceRangeInputs()
    setupPriceFilters()
    const filters = getFilters()

    if (drawerForm) {
      drawerForm.querySelectorAll('input[type="checkbox"]').forEach((cb) => {
        cb.checked = !!filters[cb.name]?.includes(cb.value)
      })

      const minInput = drawerForm.querySelector(
        'input[name="filter.v.price.gte"]',
      )
      const maxInput = drawerForm.querySelector(
        'input[name="filter.v.price.lte"]',
      )
      if (minInput) minInput.value = filters["filter.v.price.gte"]?.[0] || ""
      if (maxInput) maxInput.value = filters["filter.v.price.lte"]?.[0] || ""

      // Open all filter accordions
      drawerForm.querySelectorAll("details").forEach((d) => (d.open = true))
    }

    // Sync sort radios
    const urlParams = new URLSearchParams(window.location.search)
    const sortBy = urlParams.get("sort_by")

    document
      .querySelectorAll('.mobile-facets__checkbox[type="radio"]')
      .forEach((radio) => {
        const isChecked = radio.value === sortBy
        radio.checked = isChecked

        const label = radio.closest(".mobile-facets__label")
        if (label) {
          if (isChecked && !radio.dataset.default) {
            label.classList.add("active")
          } else {
            // label.classList.remove("active")
          }
        }
      })

    // Only retain sort_by in filters if user actually selected it via URL
    // if (!sortBy) {
    //   delete filters["sort_by"]
    // }

    renderQuick(filters)
    // --- [PATCH: Ensure Sort Pill Label Is Always Up To Date After AJAX, Both Radios & Select] ---
    setTimeout(function () {
      const sortByPill = document.querySelector(
        ".quick-filter-pill[data-sort-by]",
      )
      let sortLabel = null
      // Prefer radio label
      const sortRadio = document.querySelector('input[name="sort_by"]:checked')
      if (sortRadio) {
        let labelElem =
          document.querySelector(`label[for="${sortRadio.id}"]`) ||
          sortRadio.closest("label") ||
          sortRadio.parentElement
        if (labelElem) {
          sortLabel = labelElem.textContent.trim()
        }
      } else {
        // Fallback: select box
        const sortSelect = document.querySelector('select[name="sort_by"]')
        if (sortSelect) {
          const selected = sortSelect.querySelector("option:checked")
          if (selected) {
            sortLabel = selected.textContent.trim()
          }
        }
      }
      if (sortByPill && sortLabel) {
        sortByPill.textContent = sortLabel
      }
    }, 80)
    // Force quick filters container to left on first load
    const pillContainer = document.querySelector(".quick-filter-main")
    if (pillContainer) pillContainer.scrollLeft = 0
    rebindPriceRangeInputs()
    fixPriceRangeDataMax()
    setupDrawerClearButton()
    document.querySelectorAll('input[name="sort_by"]').forEach((radio) => {
      radio.addEventListener("change", () => {
        userSelectedSort = true
      })
      radio.addEventListener("click", () => {
        userManuallySorted = true
      })
    })
    setTimeout(() => {
      renderQuick(getFilters())
      window.justClickedQuickFilter = false
      window.justClickedQuickFilterTimestamp = null
    }, 50)
  }

  // Shows or hides the mobile clear filters button based on active pills
  function toggleMobileClearButton() {
    const clearBtn = document.querySelector(".clear-filters-mobile-only")
    const anyActive = document.querySelectorAll(".quick-filter-pill").length > 0
    if (clearBtn) clearBtn.style.display = anyActive ? "flex" : "none"
  }

  // Renders all quick filter pills based on current filters and pill order; updates UI and scrolls as needed
  function renderQuick(filters) {
    if (!mostPopularOptionsFromResponse?.length) {
      mostPopularOptionsFromResponse = extractLiveMostPopularOptionsFromDOM()
    }
    // Prevent flicker/blink when clicking on quick filter: If a quick filter was just clicked, skip full pill rebuild for this event.
    // Strong pill-flicker prevention: skip rendering for 200ms after quick filter click
    if (window.justClickedQuickFilter) {
      if (!window.justClickedQuickFilterTimestamp) {
        window.justClickedQuickFilterTimestamp = Date.now()
      }
      // If within 200ms of click, skip rendering
      if (Date.now() - window.justClickedQuickFilterTimestamp < 200) {
        return
      } else {
        window.justClickedQuickFilter = false
        window.justClickedQuickFilterTimestamp = null
      }
    }

    quickContainer.innerHTML = ""

    // --- PATCH: Ensure all active filters are present in pillOrderArr (leftmost is newest) ---
    // --- PATCH: All pills (including sort_by) behave as "newest leftmost" ---
    // 1. Start from pillOrderArr from localStorage
    let pillOrderArr = getPillOrderArr()

    // 2. Add any selected filters (including sort_by) not present in pillOrderArr (unshift: leftmost/newest)
    Object.entries(filters).forEach(([key, values]) => {
      if (key.startsWith("filter.v.price")) return
      values.forEach((value) => {
        const exists = pillOrderArr.some(([k, v]) => k === key && v === value)
        if (!exists) {
          pillOrderArr.unshift([key, value])
        }
      })
    })

    // 3. Remove pills no longer selected
    pillOrderArr = pillOrderArr.filter(([key, value]) => {
      if (key === "sort_by") return filters["sort_by"]?.[0] === value
      if (key === "price") {
        const min = filters["filter.v.price.gte"]?.[0] || ""
        const max = filters["filter.v.price.lte"]?.[0] || ""
        return value === `${min}_${max}` && (min || max)
      }
      return filters[key]?.includes(value)
    })

    // 4. Save order
    setPillOrderArr(pillOrderArr)

    // 5. Render: newest at left
    ;[...pillOrderArr].reverse().forEach(([key, value]) => {
      // Insert deduplication/visibility logic for Most Popular before pill creation
      if (key === "filter.p.m.custom.most_popular") {
        // Compare filter param values, not just label/text, for language-agnostic deduplication
        const quickBtn = Array.from(
          document.querySelectorAll(".quick-filter-main .custom-button a"),
        ).find((a) => {
          const btnUrl = new URL(a.href, location.origin)
          const btnVal = btnUrl.searchParams.get(
            "filter.p.m.custom.most_popular",
          )
          return (
            btnVal && btnVal.trim().toLowerCase() === value.trim().toLowerCase()
          )
        })
        if (quickBtn && quickBtn.classList.contains("selected")) {
          return
        }
        // Only show pill if option is checked in drawer
        const drawerCheckbox = Array.from(
          document.querySelectorAll(
            'input[name="filter.p.m.custom.most_popular"]',
          ),
        ).find(
          (input) =>
            decodeURIComponent(input.value).trim().toLowerCase() ===
            value.trim().toLowerCase(),
        )
        if (!drawerCheckbox || !drawerCheckbox.checked) return
      }
      let pill, label
      if (key === "sort_by") {
        // Human label for sort
        let sortLabel = value
        const sortRadio = document.querySelector(
          'input[name="sort_by"]:checked',
        )
        if (sortRadio) {
          let labelElem =
            document.querySelector(`label[for="${sortRadio.id}"]`) ||
            sortRadio.closest("label") ||
            sortRadio.parentElement
          if (labelElem) sortLabel = labelElem.textContent.trim()
        } else {
          const sortSelect = document.querySelector('select[name="sort_by"]')
          if (sortSelect) {
            const selected = sortSelect.querySelector("option:checked")
            if (selected) sortLabel = selected.textContent.trim()
          }
        }
        const fallbackSortLabels = {
          "best-selling": "Best Selling",
          "title-ascending": "Alphabetically, A–Z",
          "title-descending": "Alphabetically, Z–A",
          "price-ascending": "Price, Low to High",
          "price-descending": "Price, High to Low",
          "created-descending": "Date, new to old",
          "created-ascending": "Date, old to new",
          manual: "Featured",
        }
        if (!sortLabel || sortLabel === value) {
          sortLabel = fallbackSortLabels[value.toLowerCase()] || value
        }
        pill = document.createElement("span")
        pill.className = "quick-filter-pill"
        pill.textContent = sortLabel
        pill.setAttribute("data-sort-by", value.toLowerCase())
      } else if (key === "price") {
        const [min, max] = value.split("_")
        label = `Price: ${min ? currency + min : ""}${min && max ? " - " : ""}${max ? currency + max : ""}`
        pill = document.createElement("span")
        pill.className = "quick-filter-pill"
        pill.textContent = label
        pill.setAttribute("data-price", "1")
      } else if (key === "filter.p.m.custom.most_popular") {
        pill = document.createElement("span")
        pill.className = "quick-filter-pill"
        pill.textContent = value
        pill.dataset.p = `filter.p.m.custom.most_popular|${value}`
      } else {
        pill = document.createElement("span")
        pill.className = "quick-filter-pill"
        pill.textContent = value
        pill.dataset.p = key + "|" + value
      }
      // Insert every pill at the beginning so newest is always leftmost
      quickContainer.insertBefore(pill, quickContainer.firstChild)
    })

    // Show quick filter container only if there are pills
    if (quickContainer.children.length > 0) {
      quickContainer.style.display = "flex"
    } else {
      quickContainer.style.display = "none"
    }

    // Ensure the first pill is visible (for mobile, resizing, etc.)
    if (window.quickFilterJustAdded) {
      if (window.skipScrollBecauseOfQuickFilterClick) {
        window.skipScrollBecauseOfQuickFilterClick = false
        return
      }
      if (!window.quickFilterClickPreventScroll) {
        tryScrollLeft()
      }
      window.quickFilterJustAdded = false
    }

    // --- Scroll to left on mobile after pills are rendered (requestAnimationFrame version)
    if (window.innerWidth <= 767) {
      if (window.skipScrollBecauseOfQuickFilterClick) {
        window.skipScrollBecauseOfQuickFilterClick = false
      } else if (!window.quickFilterClickPreventScroll) {
        let attempt = 0
        const maxTries = 20
        const poll = () => {
          const pillContainer = document.querySelector(".quick-filter-main")
          const firstPill = pillContainer?.querySelector(".quick-filter-pill")
          if (pillContainer && firstPill) {
            const sw = pillContainer.scrollWidth
            const cw = pillContainer.clientWidth
            if (sw > cw) {
              requestAnimationFrame(() => {
                pillContainer.scrollTo({ left: 0, behavior: "smooth" })
                setTimeout(() => {
                  pillContainer.scrollLeft = 0
                }, 100)
              })
            }
          } else if (++attempt < maxTries) {
            requestAnimationFrame(poll)
          }
        }
        requestAnimationFrame(poll)
      }
    }

    // Always reset the quick filter click flag after rendering completes (not a pill click)
    window.quickFilterClickPreventScroll = false

    // Show/hide Clear All button
    const isRealFilterActive = Object.keys(filters).some((key) => {
      if (key === "sort_by") return false
      const val = filters[key]
      return Array.isArray(val) && val.length > 0
    })
    clearAllBtn.style.display = isRealFilterActive ? "inline-block" : "none"

    // Update custom buttons
    document
      .querySelectorAll(".quick-filter-main .custom-button a")
      .forEach((a) => {
        const params = new URL(a.href).searchParams
        const [key, value] = params.entries().next().value || []
        a.classList.toggle("selected", !!filters[key]?.includes(value))
      })

    // Hide/show quick filter buttons based on active values
    const normalize = (str) =>
      str
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/^-+|-+$/g, "")
    document
      .querySelectorAll(".quick-filter-main .custom-button a")
      .forEach((btn) => {
        const url = new URL(btn.href)
        const params = url.searchParams
        const filterKey = [...params.keys()].find((k) =>
          k.includes("filter.p.m.custom.most_popular"),
        )
        if (!filterKey) return
        const val = params.get(filterKey)
        const shouldShow = mostPopularOptionsFromResponse.some(
          (opt) => normalize(opt) === normalize(val),
        )
        btn.closest(".custom-button").style.display = shouldShow
          ? "inline-block"
          : "none"
      })

    // Attach mobile clear handler after rendering quick filters
    if (typeof attachMobileClearHandler === "function")
      attachMobileClearHandler()

    // Always reset the quick filter click flag after rendering completes
    window.justClickedQuickFilter = false
    window.justClickedQuickFilterTimestamp = null
  }

  // Applies price filters from drawer inputs and triggers filter update
  function applyPriceFilters() {
    if (!drawerForm) return

    const minInput = drawerForm.querySelector(
      'input[name="filter.v.price.gte"]',
    )
    const maxInput = drawerForm.querySelector(
      'input[name="filter.v.price.lte"]',
    )
    const min = minInput?.value.trim()
    const max = maxInput?.value.trim()

    const filters = getFilters()

    // Add only if numeric and not empty
    if (min && !isNaN(min)) {
      filters["filter.v.price.gte"] = [min]
    } else {
      delete filters["filter.v.price.gte"]
    }

    if (max && !isNaN(max)) {
      filters["filter.v.price.lte"] = [max]
    } else {
      delete filters["filter.v.price.lte"]
    }

    // Optional validation
    if (min && max && parseFloat(min) > parseFloat(max)) {
      alert("Minimum price cannot be greater than maximum price")
      return
    }

    updateURL(filters)
  }

  // Event handlers
  if (drawerForm) {
    drawerForm.addEventListener("change", (e) => {
      if (!e.target.name.startsWith("filter.v.price")) {
        updateURL(getFilters())
      }
    })
  }

  quickContainer.addEventListener("click", (e) => {
    // Store the event globally for scroll logic
    window.quickFilterLastEvent = e
    const pill = e.target.closest(".quick-filter-pill")
    if (!pill) return

    // Set robust global flag for quick filter pill click
    window.justClickedQuickFilter = true
    // Set scroll-prevent flag for quick filter pill click (legacy)
    window.quickFilterClickPreventScroll = true
    // Set new global skipScrollBecauseOfQuickFilterClick flag
    window.skipScrollBecauseOfQuickFilterClick = true
    setTimeout(() => {
      window.skipScrollBecauseOfQuickFilterClick = false
    }, 1000)

    const keyValue = pill.dataset.p
    let key, value
    if (keyValue) {
      ;[key, value] = keyValue.split("|")
    } else {
      key = pill.dataset.key
      value = pill.dataset.value
    }

    // --- Uncheck matching drawer input (checkbox/radio) before updating URL/content ---
    // New logic: Use data-p attribute if present, fallback to data-sort-by/data-price logic.
    if (pill.hasAttribute("data-p")) {
      const pillType = pill.getAttribute("data-p").split("|")[0]
      const pillValue = pill.getAttribute("data-p").split("|")[1]
      const drawerInputSelector = `[name="${pillType}"][value="${pillValue}"]`
      const drawerInput = document.querySelector(drawerInputSelector)
      if (drawerInput && drawerInput.checked) {
        drawerInput.click() // Simulate a click to uncheck and trigger change events
      }
    } else if (drawerForm) {
      // Fallback to old logic for legacy pills
      const checkbox = drawerForm.querySelector(
        `input[name="${key}"][value="${value}"]`,
      )
      if (checkbox) {
        checkbox.checked = false
        checkbox.dispatchEvent(new Event("change", { bubbles: true }))
      }
    }

    const filters = getFilters()

    // --- Update pill order array so that the removed/added pill is always leftmost (newest) ---
    let pillOrderArr = getPillOrderArr()
    pillOrderArr = pillOrderArr.filter(([k, v]) => !(k === key && v === value))
    pillOrderArr.unshift([key, value])
    setPillOrderArr(pillOrderArr)

    if (pill.hasAttribute("data-sort-by")) {
      delete filters["sort_by"]
      updateURL(filters)
      // Reset scroll-prevent flag after navigation
      setTimeout(() => {
        window.quickFilterClickPreventScroll = false
        window.justClickedQuickFilter = false
        window.skipScrollBecauseOfQuickFilterClick = false
      }, 1000)
      return
    }

    if (pill.hasAttribute("data-price")) {
      delete filters["filter.v.price.gte"]
      delete filters["filter.v.price.lte"]
      if (drawerForm) {
        drawerForm
          .querySelectorAll('input[name^="filter.v.price"]')
          .forEach((i) => (i.value = ""))
      }
    } else {
      if (filters[key]) {
        filters[key] = filters[key].filter((v) => v !== value)
        if (!filters[key].length) delete filters[key]
      }
    }

    loadContent(filters)
    // Reset scroll-prevent flag after navigation
    setTimeout(() => {
      window.quickFilterClickPreventScroll = false
      window.justClickedQuickFilter = false
      window.skipScrollBecauseOfQuickFilterClick = false
    }, 1000)
    toggleMobileClearButton()
  })

  clearAllBtn.addEventListener("click", () => {
    if (drawerForm) {
      drawerForm
        .querySelectorAll('input[type="checkbox"]')
        .forEach((cb) => (cb.checked = false))
      drawerForm
        .querySelectorAll('input[name^="filter.v.price"]')
        .forEach((i) => (i.value = ""))
    }
    // Clear sort selection
    clearSortRadios()
    // Clear custom button filters
    document
      .querySelectorAll(".quick-filter-main .custom-button a.selected")
      .forEach((a) => {
        a.classList.remove("selected")
      })

    updateURL({})
    setTimeout(() => {
      rebindShowMoreButton()
    }, 0)
    // Removed scroll-to-left logic here
  })

  // --- Add logic for .quick-filter-clear-all and .quick-filter-clear-all-mobile buttons ---
  document.querySelectorAll(".quick-filter-clear-all").forEach((button) => {
    button.addEventListener("click", (e) => {
      e.preventDefault()
      const url = new URL(window.location.href)
      const params = url.searchParams
      const preserveParams = ["q", "options[prefix]"]
      const preserved = {}
      preserveParams.forEach((key) => {
        if (params.has(key)) preserved[key] = params.get(key)
      })
      ;[...params.keys()].forEach((key) => {
        if (!preserveParams.includes(key)) params.delete(key)
      })
      Object.keys(preserved).forEach((key) => {
        params.set(key, preserved[key])
      })
      history.pushState({}, "", `${url.pathname}?${params.toString()}`)
      if (typeof renderFilters === "function") {
        renderFilters()
      } else if (
        window.renderFilters &&
        typeof window.renderFilters === "function"
      ) {
        window.renderFilters()
      }
    })
  })

  document
    .querySelectorAll(".quick-filter-main .custom-button a")
    .forEach((a) => {
      // Set the flag on both click and mousedown for best results
      a.addEventListener("mousedown", () => {
        window.justClickedQuickFilter = true
        window.justClickedQuickFilterTimestamp = Date.now()
      })
      a.addEventListener("click", async (e) => {
        e.preventDefault()
        // Store the event globally for scroll logic
        window.quickFilterLastEvent = e
        window.skipScrollOnQuickFilter = true
        const params = new URL(a.href).searchParams
        const [key, value] = params.entries().next().value || []

        const filters = getFilters()
        filters[key] = filters[key] || []

        if (filters[key].includes(value)) {
          filters[key] = filters[key].filter((v) => v !== value)
        } else {
          filters[key].push(value)
        }

        if (!filters[key].length) delete filters[key]

        // Track quick filter pill order for re-add as leftmost (newest)
        let pillOrderArr = getPillOrderArr()
        pillOrderArr = pillOrderArr.filter(
          ([k, v]) => !(k === key && v === value),
        )
        pillOrderArr.unshift([key, value])
        setPillOrderArr(pillOrderArr)

        if (drawerForm) {
          const checkbox = drawerForm.querySelector(
            `input[name="${key}"][value="${value}"]`,
          )
          if (checkbox) checkbox.checked = !!filters[key]?.includes(value)
        }

        // 🔄 Update and reload
        window.quickFilterJustAdded = true
        await updateURL(filters)
      })
    })

  // Initialize
  setupPriceFilters()
  syncAll()
  swatchChangesCard()
  // Force quick filters container to left on first load (use unique variable to avoid conflict)
  const pillContainerInitial = document.querySelector(".quick-filter-main")
  if (pillContainerInitial) {
    pillContainerInitial.scrollLeft = 0
  }
  // Run clear filters visibility logic once on load
  toggleClearFiltersVisibility()
  // Insert quick filters container positioning
  insertQuickFiltersContainer()
  // Inject clear filters button for mobile
  injectClearFiltersButtonMobile()
  // Enable mobile clear filters binding
  bindMobileClearFilters()
  // Enable pill container drag scrolling
  const pillContainer = document.querySelector(".quick-filter-main")
  if (pillContainer) {
    let isDown = false
    let startX
    let scrollLeft
    pillContainer.addEventListener("mousedown", (e) => {
      isDown = true
      pillContainer.classList.add("dragging")
      startX = e.pageX - pillContainer.offsetLeft
      scrollLeft = pillContainer.scrollLeft
    })
    pillContainer.addEventListener("mouseleave", () => {
      isDown = false
      pillContainer.classList.remove("dragging")
    })
    pillContainer.addEventListener("mouseup", () => {
      isDown = false
      pillContainer.classList.remove("dragging")
    })
    pillContainer.addEventListener("mousemove", (e) => {
      if (!isDown) return
      e.preventDefault()
      const x = e.pageX - pillContainer.offsetLeft
      const walk = (x - startX) * 1.5
      pillContainer.scrollLeft = scrollLeft - walk
    })
  }
  window.addEventListener("resize", () => {
    const pillContainer = document.querySelector(".quick-filter-main")
    const firstPill = pillContainer?.querySelector(".quick-filter-pill")
    if (pillContainer && firstPill) {
      firstPill.scrollIntoView({
        behavior: "auto",
        block: "nearest",
        inline: "start",
      })
    }
  })
})
// ============================================================================
// Clear All, Mobile/Drawer, Utility
// ============================================================================
// Injects a clear filters button for mobile view above the filter drawer
function injectClearFiltersButtonMobile() {
  if (document.querySelector(".quick-filter-clear-all-mobile.in-header")) return

  const clearFilters =
    document.querySelector(".active-facets__button-remove").textContent ||
    "Clear Filters"
  const clearBtn = document.createElement("button")
  clearBtn.className =
    "quick-filter-clear-all quick-filter-clear-all-mobile in-header button button--tertiary"
  clearBtn.innerText = clearFilters
  clearBtn.style.display = "none"

  clearBtn.addEventListener("click", () => {
    const drawerClearLink = document.querySelector(".mobile-facets__clear")
    if (drawerClearLink) {
      drawerClearLink.click()
      // After clearing, update the URL to remove all filter parameters (except default search/sort)
      // Wait for the drawerClearLink to process its click (which may be async), then update URL
      setTimeout(() => {
        // Remove filter.* and price filters from URL, keep only search/sort/page
        const url = new URL(window.location.href)
        const params = url.searchParams
        // Collect keys to delete
        const keysToDelete = []
        params.forEach((_, key) => {
          if (
            key.startsWith("filter.") ||
            key === "filter.v.price.gte" ||
            key === "filter.v.price.lte"
          ) {
            keysToDelete.push(key)
          }
        })
        keysToDelete.forEach((k) => params.delete(k))
        // Optionally, remove "sort_by" only if it's not the default (manual)
        if (
          params.get("sort_by") === null ||
          params.get("sort_by") === "manual"
        ) {
          params.delete("sort_by")
        }
        // Remove "page" param (reset pagination)
        params.delete("page")
        // Compose clean URL
        const newUrl =
          params.toString().length > 0
            ? window.location.pathname + "?" + params.toString()
            : window.location.pathname
        // Use history.replaceState to update URL without reload
        history.replaceState({}, "", newUrl)
        // Optionally, trigger a custom event if needed
        document.dispatchEvent(new Event("filters:updated"))
      }, 0)
      // Removed pollForPills/scroll-to-left logic here
    }
  })

  const mobileDrawer = document.querySelector(
    "menu-drawer.mobile-facets__wrapper",
  )
  if (mobileDrawer && mobileDrawer.parentNode) {
    mobileDrawer.parentNode.insertBefore(clearBtn, mobileDrawer)
  }
}

// Overrides price input behavior to trigger AJAX updates on blur/Enter/input
function overridePriceInputsBehavior(form) {
  if (!form) return
  const minInput = form.querySelector('input[name="filter.v.price.gte"]')
  const maxInput = form.querySelector('input[name="filter.v.price.lte"]')
  const commitPrice = () => {
    const filters = getFilters()
    updateURL(filters)
  }
  if (minInput && !minInput.classList.contains("price-bound")) {
    minInput.addEventListener("input", (e) => e.stopPropagation())
    minInput.addEventListener("blur", commitPrice)
    minInput.addEventListener("keydown", (e) => {
      if (e.key === "Enter") {
        e.preventDefault()
        commitPrice()
      }
    })
    minInput.classList.add("price-bound")
  }
  if (maxInput && !maxInput.classList.contains("price-bound")) {
    maxInput.addEventListener("input", (e) => e.stopPropagation())
    maxInput.addEventListener("blur", commitPrice)
    maxInput.addEventListener("keydown", (e) => {
      if (e.key === "Enter") {
        e.preventDefault()
        commitPrice()
      }
    })
    maxInput.classList.add("price-bound")
  }
}

// Shows/hides clear filter buttons based on whether any filters are active (desktop & mobile)
function toggleClearFiltersVisibility() {
  const urlParams = new URLSearchParams(window.location.search)
  const hasAnyFilter = [...urlParams.keys()].some(
    (key) => key.startsWith("filter.") || key === "sort_by",
  )

  const desktopClear = document.querySelector(".quick-filter-clear-all-desktop")
  const mobileClear = document.querySelector(
    ".quick-filter-clear-all-mobile.in-header",
  )
  const quickClear = document.querySelector(
    ".quick-filter-clear-all:not(.in-header)",
  )

  if (desktopClear) {
    desktopClear.style.display =
      hasAnyFilter && window.innerWidth > 767 ? "inline-block" : "none"
  }

  if (mobileClear) {
    mobileClear.style.display =
      hasAnyFilter && window.innerWidth <= 767 ? "inline-block" : "none"
  }

  if (quickClear) {
    quickClear.style.display =
      window.innerWidth > 767 && hasAnyFilter ? "inline-block" : "none"
  }
}

document.addEventListener("filters:updated", toggleClearFiltersVisibility)
window.addEventListener("resize", toggleClearFiltersVisibility)
window.addEventListener("popstate", toggleClearFiltersVisibility)

const clearFilterObserver = new MutationObserver(() => {
  toggleClearFiltersVisibility()
})
clearFilterObserver.observe(document.body, {
  childList: true,
  subtree: true,
})

// Binds mobile clear filters button to reset filters, update URL, and re-render pills
function bindMobileClearFilters() {
  document
    .querySelector(".quick-filter-clear-all-mobile")
    ?.addEventListener("click", function (e) {
      e.preventDefault()

      // Trigger drawer clear to reset form inputs
      document.querySelector(".mobile-facets__clear")?.click()

      // Clean up URL parameters (keep 'q' or other search params if needed)
      const params = new URLSearchParams(window.location.search)
      ;["filter.", "sort_by", "page"].forEach((prefix) => {
        ;[...params.keys()].forEach((k) => {
          if (k.startsWith(prefix)) params.delete(k)
        })
      })

      const cleanURL =
        window.location.pathname + (params.toString() ? "?" + params : "")
      history.replaceState({}, "", cleanURL)

      // Safely reload the drawer using loadContent if available
      const form = document.querySelector("facet-filters-form")
      if (form && typeof form.loadContent === "function") {
        form.loadContent()
      }

      // Re-render pills and visibility toggles
      toggleClearFiltersVisibility()
    })
}

document.addEventListener("filters:updated", toggleClearFiltersVisibility)
document
  .querySelectorAll(".mobile-facets__footer .button--primary")
  .forEach((btn) => {
    btn.addEventListener("click", () => {
      setTimeout(toggleClearFiltersVisibility, 300)
    })
  })

// Ensures the quick filters container is correctly inserted in the DOM after custom blocks
function insertQuickFiltersContainer() {
  const container = document.querySelector(".quick-filter-main")
  const target = container?.querySelector(".multiple-custom-block")
  const pillsWrapper = document.querySelector(".quick-filters-container")

  if (pillsWrapper && target && container.contains(target)) {
    container.insertBefore(pillsWrapper, target)
  } else if (pillsWrapper && container) {
    container.appendChild(pillsWrapper)
  }
}

// ============================================================================
// Show More Button Logic
// ============================================================================
// Handles AJAX loading and appending of more products when the "Show More" button is clicked
function handleShowMoreClick(e) {
  e.preventDefault()
  const button = e.currentTarget

  let page = parseInt(button.dataset.page || "2")
  if (!page || isNaN(page)) page = 2

  const baseUrl =
    button.dataset.baseUrl || window.location.pathname.split("?")[0]
  const query = new URLSearchParams(window.location.search)
  query.set("page", page)
  const url = `${baseUrl}?${query.toString()}`

  const grid =
    document.querySelector("#product-grid") ||
    document.querySelector("#ProductGridContainer")
  const countElem = document.querySelector(".custom-show-product")
  const totalElem = document.querySelector(".custom-total-product")
  const progress = document.querySelector(".load-more-progress-bar")
  const spinner = document.querySelector(".load-more-spinner")

  if (countElem && grid) {
    const visibleProducts = grid.querySelectorAll(".grid__item")
    countElem.textContent = visibleProducts.length.toString()
  }

  const totalCount = parseInt(totalElem?.textContent || "0")

  button.classList.add("hidden")
  button.dataset.page = (page + 1).toString()
  spinner?.classList.remove("hidden")

  fetch(url)
    .then((res) => res.text())
    .then((html) => {
      const wrapper = document.createElement("div")
      wrapper.innerHTML = html

      const gridWrapper =
        wrapper.querySelector("#product-grid") ||
        wrapper.querySelector("#ProductGridContainer")
      const newItems = gridWrapper
        ? gridWrapper.querySelectorAll(".grid__item")
        : []
      // --- Use display count instead of DOM count
      const existingCount = parseInt(countElem?.textContent || "0")
      let appendCount = 0
      newItems.forEach((item) => {
        grid.appendChild(item)
        appendCount++
      })
      swatchChangesCard()
      if (typeof theme_custom?.percussiveMassageSlider === "function") {
        theme_custom.percussiveMassageSlider()
      }
      // --- After appending, update count based on previous count + new items
      const updatedCount = existingCount + appendCount
      const newTotalElem = wrapper.querySelector(".custom-total-product")
      if (newTotalElem && totalElem)
        totalElem.textContent = newTotalElem.textContent
      if (progress && totalElem) {
        const totalValue = parseInt(totalElem.textContent || "0")
        progress.style.width = `${(updatedCount / totalValue) * 100}%`
      }

      const newLoadMore = wrapper.querySelector(".load-more-part")
      const curLoadMore = document.querySelector(".load-more-part")
      if (newLoadMore && curLoadMore) {
        curLoadMore.replaceWith(newLoadMore.cloneNode(true))
        // Now update the count after DOM replacement so it isn't overwritten
        const newCountElem = document.querySelector(".custom-show-product")
        const newTotalElemAfterReplace = document.querySelector(
          ".custom-total-product",
        )
        if (newCountElem) newCountElem.textContent = updatedCount.toString()
        if (newTotalElemAfterReplace && newTotalElem) {
          newTotalElemAfterReplace.textContent = newTotalElem.textContent
        }
        // Move rebindShowMoreButton call AFTER product cards are appended and inserted into the DOM
        setTimeout(function () {
          if (typeof rebindShowMoreButton === "function") {
            rebindShowMoreButton()
          }
        }, 0)

        // Update next button page from current grid count
        const newButton = document.querySelector(".load-more-btn")
        if (newButton) {
          const itemsPerPage = parseInt(
            document.querySelector(".custom-show-product")?.dataset.perPage ||
              "36",
          )
          const nextPage = Math.ceil(updatedCount / itemsPerPage) + 1
          newButton.dataset.page = nextPage.toString()
        }
      }
    })
    .catch(() => {})
    .finally(() => {
      spinner?.classList.add("hidden")
    })
}

// Rebinds the Show More button click handler after DOM replacement
function rebindShowMoreButton() {
  const showMoreBtn = document.querySelector(".load-more-btn")
  if (showMoreBtn) {
    showMoreBtn.removeEventListener("click", handleShowMoreClick)
    showMoreBtn.addEventListener("click", handleShowMoreClick)
  }
}
window.rebindShowMoreButton = rebindShowMoreButton

// ============================================================================
// Miscellaneous/Global Event Handlers
// ============================================================================
if (typeof renderFilters === "function") {
  window.renderFilters = renderFilters
}
document.addEventListener("click", function (e) {
  const clearBtn = e.target.closest(".js-drawer-clear")
  if (clearBtn) {
    e.preventDefault()
    const clearURL = clearBtn.getAttribute("href")
    history.pushState({}, "", clearURL)
    if (
      typeof FacetFiltersForm !== "undefined" &&
      typeof FacetFiltersForm.resetAllFilters === "function"
    ) {
      FacetFiltersForm.resetAllFilters()
    }
    if (typeof loadContent === "function") {
      loadContent(clearURL)
    } else if (typeof renderFilters === "function") {
      renderFilters()
    }
  }
})

// Binds the mobile drawer clear button to reset all filters and reload content
function attachMobileClearHandler() {
  document.querySelectorAll(".mobile-facets__clear").forEach((btn) => {
    btn.removeEventListener("click", resetAllFiltersAndReload) // prevent duplicates
    btn.addEventListener("click", function (e) {
      e.preventDefault()
      resetAllFiltersAndReload()
    })
  })
}

attachMobileClearHandler()

document.addEventListener("click", function (e) {
  const isMedia = e.target.closest(".card__media img")
  const isContent = e.target.closest(".card__content.card__content--top")
  const card = e.target.closest(".card[data-prod-url]")
  if (
    (isMedia || isContent) &&
    card &&
    !e.target.closest("a") &&
    !e.target.closest("button")
  ) {
    const url = card.getAttribute("data-prod-url")
    if (url) {
      window.location.href = url
    }
  }
})
